export const PI = [
  { header: "Principal Investigator" },
  {
    name: "Dr. Mona Minkara",
    title: "Associate Professor, Bioengineering",
    img: "mona",
    alt: "Mona is wearing a purple and tan headscarf and a black blazer.",
    bio: "Dr. Mona Minkara directs the COMBINE (Computational Modeling for Biointerface Engineering) Lab at Northeastern University. The lab studies pulmonary surfactant, the protein-lipid mixture lining the lungs that makes breathing possible and mounts one of the body's first defenses against inhaled pathogens. Since founding the lab in 2019, Minkara has built a research program spanning the full system, from the interfacial biophysics of the alveolar surface to the four surfactant proteins that keep the lung stable. Her current work centers on SP-A and SP-D, the two that are also collectins, and on how they recognize the pathogenic glycans coating viruses, bacteria, fungi, and pollen. Using molecular dynamics, Monte Carlo, and free-energy methods, her group decodes the molecular language these proteins use to communicate. COMBINE is one of a small number of groups worldwide applying these methods to collectin-glycan recognition at this level of detail. Minkara is a blind scientist and the founding director of the Academy of Blind Scientists, and she builds the multisensory computational tools her research depends on.",
    education:"Northeastern University",
    funFact:
      "Mona completed her postdoc at the University of Minnesota and is also a blind scientist. She also has a plaque of her name at Wellesley College, her alma mater.",
  },
];

export const PhDStudents = [
  { header: "Doctoral Researcher" },
  {
      name: "Oyinlola Abosede",
      title: "PhD Student, Bioengineering",
      education:"Northeastern University",
      img: "Oyinlola",
      alt: "Oyinlola is wearing a suit and smiling towards camera.",
      linkedIn: "https://www.linkedin.com/in/prince-oyinlola-a-910655420/",
      website:"https://scholar.google.com/citations?user=YTmVm7kAAAAJ&hl=en",
      program: "Training",
      major: "",
      research: "Training",
      bio: "Oyinlola has a strong background in computational chemistry, protein-ligand docking and system visualization for protein synthesis. His research focuses on exploring the binding affinity between pulmonary surfactants and glycans for therapeutic applications, and groundbreaking impact on respiratory health. Outside the lab, he enjoys volunteering, soccer and community engagement. "
  
  },
  {
    
      name: "Md Rafid Hasan",
      title: "PhD Student, Bioengineering",
      education:"Northeastern University",
      img: "Md-Rafid",
      alt: "Rafid is wearing muslim cap and a grey kurta.",
      linkedIn: "https://www.linkedin.com/in/rafidhasan08/",
      program: "Training",
      major: "",
      research: "Training",
      bio: "Rafid computationally modelled peptide inhibitors and investigated their therapeutic potentiality against viral main protease in his bachelor’s. He also loves traveling and has traveled using both bicycle and motorbike."
  
  },
  {
    
    name: "Odame Agyapong",
    title: "PhD Student, Bioengineering",
    education:"Northeastern University",
    img: "odame",
    alt: "Odame is wearing white sweatshirt.",
    linkedIn: "https://www.linkedin.com/in/odameagyapong",
    program: "Training",
    major: "",
    research: "Training",
    bio: "Odame's research focuses on employing computational modelling techniques to provide deep insights into molecular interactions of pulmonary surfactant proteins, especially how they interact within pathogens like bacteria. He has previously leveraged computational approaches including docking, molecular dynamics simulations as well as machine learning models to identify promising drug candidates from large chemical libraries. Apart from his research work, he enjoys music and soccer."

},
{
    
    name: "Rabita Rahman Era",
    title: "PhD Student, Bioengineering",
    education:"Northeastern University",
    img: "Rabita",
    alt: "Rabita is smiling and is wearing black coat.",
    linkedIn: "",
    program: "Training",
    major: "",
    research: "Training",
    bio: "Rabita's research focuses on bacterial glycan library creation and protein engineering, using computational and molecular approches to study and design biomolecular interactions. Outside of research, she enjoys cooking, painting, gardening, and documenting her travels through videos and photography."

},
// {
    
//     name: "Zhiyuan(Frank) Qu",
//     title: "PhD Student, Bioengineering",
//     education:"Northeastern University",
//     img: "frank",
//     alt: "frank is wearing black shirt.",
//     linkedIn: "https://www.linkedin.com/in/zhiyuan-qu-9146032a0/",
//     program: "Training",
//     major: "",
//     research: "Training",
//     bio: "Frank is the first-year Ph.D student in the Department of Bioengineering. His research focuses on modeling insulin-loaded micelles interacting with pulmonary surfactant monolayers, leveraging drug delivery strategies. Outside the lab, Frank enjoys science communication, entrepreneurship, and the creativity of bartending."

// },
];

// export const mastersStudents = [{ header: "Master's Students" }];

export const postdoctoral = [
  { header: "Post Doctoral" },
  {
    name: "Duen-Shian(Ben) Wang",
    title: "Post Doctoral Researcher",
    education: "Northeastern University",
    img: "Photo_Ben",
    major:"",
    linkedIn:"https://www.linkedin.com/in/duen-shian-wang/en",
    research:"Utilization of computational methods to analyze the structure and function of pulmonary surfactant, aiming at improving the understanding of clinical pathologies such as Acute Respiratory Distress Syndrome (ARDS). Collaborates with the Program for Advancing Critical Care Translational Science (PACCTS) and the ILD Collaborative to advance knowledge of the pulmonary system from molecular mechanisms to therapeutic applications in intensive care units.",
    alt: "elfie of Ben wearing black-framed glasses, a light blue Patagonia beanie, and a brown plaid scarf. He's standing by a waterfront with calm blue water and distant shoreline buildings visible under a clear sky.",
    bio: "Duen-Shian (Ben) Wang, Ph.D. is a postdoctoral researcher in the COMBINE Lab at Northeastern University, with research interests focused on the mechanistic study of pulmonary surfactant proteins and related computational protein design. He earned his Ph.D. in Biomedical Sciences from the University of North Texas Health Science Center and previously worked in the biotech industry on protein engineering projects before joining Northeastern. Outside of research, he enjoys hiking, trail walking, historical tours, and playing volleyball.",
  },
  {
    name: "Zahra Nikfarjam",
    title: "Post Doctoral Researcher",
    education: "Northeastern University",
    img: "Zahra",
    major:"",
    linkedIn:"",
    research:"Utilization of computational methods to analyze the structure and function of pulmonary surfactant, aiming at improving the understanding of clinical pathologies such as Acute Respiratory Distress Syndrome (ARDS). Collaborates with the Program for Advancing Critical Care Translational Science (PACCTS) and the ILD Collaborative to advance knowledge of the pulmonary system from molecular mechanisms to therapeutic applications in intensive care units.",
    alt: "Portrait of Zahra wearing clear-framed glasses and a colorful patterned hijab in navy blue, red, and beige tones. She's smiling warmly at the camera against a softly blurred outdoor background with trees.",
    bio: "Zahra is a multidisciplinary computational chemist with expertise in molecular simulations, structure-based drug design, and evolutionary bioinformatics. Her research includes molecular dynamics simulations, protein-ligand interactions, and ancestral sequence reconstruction, with a focus on LUCA and protein domain evolution. At the COMBINE LAB, she is developing a multi-purpose bacterial glycan database. She enjoys watching films, writing poetry, engaging with communities, and exploring diverse cultures.",
  },
];

export const graduateStudents = [
  { header: "Graduate Researcher" },
  {
    name: "Shruthi Laavanyaa Narendra Deva",
    title: "Graduate Researcher",
    img: "shruthi",
    education: "Northeastern University",
    major: "M.S. Biotechnology",
    linkedIn:"https://www.linkedin.com/in/shruthilaavanyaan/",
    research: "Training",
    alt: "Shruthi is wearing a black blazer and is smiling towards camera.",
    bio: "Shruthi is M.S. Biotechnology candidate at Northeastern University with a background in biotechnology, clinical research systems, and applied data analysis.  At the COMBINE LAB, I assist with research related to bacterial glycans and computational approaches that connect molecular biology, drug discovery, and protein evolution.",
  },
   {
    name: "Hadeer Elbohy",
    title: "Research Assistant",
    img: "hadeer",
    education: "Northeastern University",
    major: "M.S in Medicinal Chemistry and Drug Discovery",
    linkedIn:"https://www.linkedin.com/in/hadeer-elbohy-0aba3a216",
    research: "Training",
    alt: "Shruthi is wearing a black blazer and is smiling towards camera.",
    bio: "Hadeer Elbohy is a medicinal chemist with a Master's degree in Medicinal Chemistry and Drug Discovery, where I developed a strong foundation in experimental chemistry. Currently, I work in the Minkara Lab , where my research bridges experimental and computational chemistry. My work focuses on bacterial glycans, with the goal of developing a comprehensive, multipurpose bacterial glycan database using molecular dynamics simulation platforms such as Amber, GROMACS, and CHARMM. Outside the lab, I enjoy reading books, playing piano, and hiking.",
  },

]

export const coopStudents = [
  { header: "Co-op Student" },
  {
    name: "Nimishamba Shekhar Murthy",
    title: "Master’s Student, Full-Time Co-op",
    img: "nimisha",
    education: "Northeastern University",
    major: "Systems, Synthetic and Computational Biology",
    linkedIn:"https://www.linkedin.com/in/nimishamba-s-6507b1236",
    research: "Training",
    alt: "Nimisha is wearing a green shirt smiling towards camera.",
    bio: "Nimisha is a graduate student working on dataset search and preparation as well as molecular dynamics simulations of bacterial glycan structures. Outside the lab, she enjoys watching movies/TV shows and exploring new teas and coffees. ",
  },

]

export const undergraduateStudents = [
  { header: "Undergraduate Researcher" },
    {
    name: "Kathryn Tomasello",
    title: "Undergraduate Researcher",
    img: "kathryn",
    education: "Northeastern University",
    major: "Bioengineering",
    linkedIn:"https://www.linkedin.com/in/kathryn-tomasello-bb9353357",
    research: "Training",
    alt: "Kathryn is wearing a violet shirt and smiling towards camera.",
    bio: "Kathryn is a second-year undergraduate student studying bioengineering with an interest in cell and tissue engineering. She is passionate about exploring computational approaches to advance biomedical research and therapeutic development. Outside of the lab, she enjoys sketching, hiking, and traveling to new places. ",
  },
  {
    name: "Yash Dhawan",
    title: "Undergraduate Researcher",
    img: "yash",
    education: "Northeastern University",
    major: "Bioengineering",
    linkedIn:"https://www.linkedin.com/in/yash-dhawan1",
    research: "Training",
    alt: "Milo is wearing a white shirt and black blazer smiling towards camera.",
    bio: "Yash Dhawan is a fourth-year Bioengineering major with a minor in Entrepreneurial Engineering and a concentration in Medical Devices and Bioimaging. I learned about the lab from taking Professor Mona Minkara's Dynamics and Control class. I am currently a part of the journal club within the lab, and my research is focused on building a database of usable bacterial glycans using various parameters like SMILES, WURCS, and IUPAC. Using these structures, I perform minimizations using MacroModel in Schrodinger so that these models can be used flexibly by others. Outside of the lab I enjoy working out and playing board games with my friends. ",
  },
  {
    name: "Milo Batista",
    title: "",
    img: "milo",
    education: "Northeastern University",
    major: "Bioengineering, Biochemistry",
    linkedIn:"https://www.linkedin.com/in/milo-batista-9942a51ab/",
    research: "Training",
    alt: "Milo is wearing a gray t-shirt.",
    bio: "Milo is currently focusing on his training within the COMBINE Lab. Born in Manhattan and raised in a serene mountain village north of NYC, Milo brings a unique background to his studies. Beyond the academic and professional realms, Milo is passionate about music, showcasing talent in playing the guitar, practicing archery for discipline and focus, and engaging in video games for relaxation and entertainment.",
  },
  {
    name: "Aayati Patel",
    title: "",
    img: "AayatiHeadshot",
    education: "Northeastern University",
    major: "Bioengineering Major with minor in Data science",
    research: "Training",
    alt: "Aayati is smiling in a grey sweater and black tshirt.",
    bio: "Aayati is a third year Bioengineering major with a minor in data science. Her research focuses on identifying natural products through computational drug discovery approaches that may have the potential to inhibit the replication and assembly of SARS-CoV-2. Out side of research, Aayati loves reading sci-fi and fantasy books, trying new cafes and restaurants, and travelling.",
  },
  {
    name: "Avery Kim",
    title: "Bachelor of Science in Bioengineering",
    img: "avery",
    education: "Northeastern University",
    major: "Bioengineering and Biochemistry",
    linkedIn: "",
    research: "Training",
    alt: "Avery is smiling.",
    bio: "Avery Kim is an undergraduate Bioengieering and Biochemistry student who is passionate about the molecular activities of various human biological processes and the intersection between technology advancements and biological research.",
  },
];

export const highschoolStudents = [
  { header : "High School Students"}, 
  {
    name: "Yixuan (Grace) Li",
    title: "High School student",
    img: "grace",
    education: "Hopkinton High School",
    linkedIn:"https://www.linkedin.com/in/yixuan-li-a449582b6/",
    research: "Training",
    alt: "Grace Li is smiling.",
    bio: "Yixuan Grace Li is a high school student at Hopkinton High School in Massachusetts. At the COMBINE Lab, she is gaining experience in computational biology by learning about molecular dynamics simulations and computational studies of pulmonary surfactant proteins. She is interested in computational biology, bioinformatics, and how computational approaches can help answer biological questions and improve human health.",
  },
  {
    name: "John Wysocki",
    title: "High School student",
    img: "John",
    education: "Pingree School",
    linkedIn:"",
    research: "Training",
    alt: "jack is smiling.",
    bio: "John is a high school student at the Pingree School. He is currently in the COMBINE Labs's training program and is excited to start his journey in molecular and biochemical research. He is very interested in medicine and biomedical sciences. In his freetime, John enjoys skiing and travelling.",
  },
]


export const accessAssistants = [
  { header: "Access Assistants" },
  {
    name: "Dr. Beth Andrews",
    title: "Senior Scientific Access Writer",
    education: "Northeastern University",
    img: "elizabeth2",
    alt:"Elizabeth wears a green top ",
    work: "Dr. Andrews’ work navigates the intersection of scientific communication and arts-based inquiry to foster collaborative writing practices and craft accessible scientific narratives. Drawing on her background as an interdisciplinary poet and scholar, her work has focused on dismantling barriers to participation within the academic community.",
    // awards: "• Outstanding Arts Based Research Award from the American Educational Research Association • Penn State University’s Distinguished Graduate Fellowship • Academy of American Poets Albert J. Kaplan Prize",
    bio: "Beth Andrews, PhD, develops the lab's grant proposals and award nominations, working closely with Dr. Minkara on the writing that carries the research program forward. Alongside the access team, she produces accessible presentations and scientific method primers, contributes to the lab's publications, and works with the team to design the systems that allow the lab to work fully nonvisually. She holds a PhD from Penn State and an MFA from Temple University. Before this work she directed art education programs and art galleries at the university level and was a professor of creative writing. Her approach comes out of arts-based research, and her subject is the image: how image forms and moves when eyesight is not the channel. Beth is a poet who founded and directed the Center for the Education of the Imagination, a rural arts nonprofit serving six Pennsylvania counties, and is now building its next form at Silver Birch Farm in Short Tract, New York.",
    // bio2: "Elizabeth is a certified wellness coach and herbalist currently working to restore and farm her family’s third-generation homestead, Silver Birch Farm, in New York State. Dr. Janney’s work won the Outstanding Arts Based Research Award from the American Educational Research Association. ",
    linkedIn: "https://www.linkedin.com/in/andrewsbeth",
  },
  {
    name: "Priyadarsini Seenivasakap Perumal",
    title: "Research Access Coordinator for the COMBINE Lab",
    education: "Northeastern University",
    img: "priya",
    alt:"Priya wears a yellow blouse.",
    linkedIn: "https://www.linkedin.com/in/priyadarsini-s/",
    website:"",
    work: "Priya’s primary responsibility is to provide scientific access by making research articles related to pulmonary surfactant accessible and describing visualizations of molecular dynamics. She ensures that the scientific material is easily accessible to Dr. Minkara. She also supports Professor Minkara’s lecture classes and works closely with the COMBINE Lab research group. ",
    bio: "Priya’s primary responsibility is to provide scientific access by making research articles related to pulmonary surfactant accessible and describing visualizations of molecular dynamics. She ensures that the scientific material is easily accessible to Dr. Minkara. She also supports Professor Minkara’s lecture classes and works closely with the COMBINE Lab research group. Priya holds educational qualifications in Biotechnology and a diploma in culinary arts. Apart from her professional responsibilities, she finds joy in cooking, which is not just a hobby but also a therapeutic activity for her.",
  },
  {
    name: "Dr. Mike Weaver",
    title: "Literature Access Coordinator for the COMBINE Lab ",
    education: "Northeastern University",
    img: "mike",
    website:"",
    alt:"Mike wears sunglasses and a gray jacket.",
    work: "Dr. Weaver is instrumental in making scientific research accessible and supporting student research in the COMBINE Lab. He is committed to mentorship and the democratization of scientific knowledge. He prepares references, assists in preparing papers for publication, and creates an accessible 'Paper of the Day' to highlight significant scientific work. ",
    bio: "Dr. Weaver is instrumental in making scientific research accessible and supporting student research in the COMBINE Lab. He is committed to mentorship and the democratization of scientific knowledge. He prepares references, assists in preparing papers for publication, and creates an accessible 'Paper of the Day' to highlight significant scientific work.Dr. Mike Weaver's academic journey led him from a postdoctoral position in Professor Kennie Merz's research group at the University of Florida to his current role as a Literature Access Coordinator at Northeastern University. Originally mentoring Dr. Minkara as a blind graduate student, his story is reminiscent of a Star Wars-esque mentor-apprentice reunion, where roles reversed when he joined the COMBINE Lab team.",
    linkedIn: "",
  },
 
];

export const phdAlumni = [
  { header: "PhD Alumni" },
   {
    name: "Deng Li",
    title: "PhD Candidate, Bioengineering",
    education:"Northeastern University",
    img: "deng2",
    alt: "Deng is wearing a blue shirt on top of a black shirt.",
    linkedIn:"https://www.linkedin.com/in/deng-li-589068127/",
    awards: " • Bioengineering Conference Travel Award, Northeastern University, USA, 2023• Ph.D. Network Travel Funding, Northeastern University, USA, 2023 • ACCESS High-Performance Computing Credits, National Science Foundation (NSF), USA, 2022International Conference Travel Grant, Ministry of Science and Technology, Taiwan, 2019• Excellent Mainland Chinese Students Scholarship, Chung Yuan Christian University, Taiwan, 2015 - 2016• Presidential Award, Chung Yuan Christian University, Taiwan, 2014 - 2017 • Presidential Award, I-Shou University, Taiwan, 2013",
    program:"Immunoproteins",
    major:"",
    research:"The application of molecular dynamics simulations to explore the molecular mechanisms of the pulmonary surfactant system, particularly those of surfactant protein D (SP-D).",
    year: "2023",
    // bio: "Research Focus: Applying molecular dynamics method on surfactant protein D (SP-D).",
    bio: "Deng's research focuses on the application of molecular dynamics simulations to explore the molecular mechanisms of the pulmonary surfactant system, particularly those of surfactant protein D (SP-D). He earned his Ph.D. in Bioengineering from Northeastern University in 2025 and is currently a postdoctoral researcher at The Scripps Research. During his master’s studies, Deng investigated the molecular mechanisms of cartilage tissue degradation. Beyond the lab, he has climbed one-third of ‘The One Hundred Peaks of Taiwan,’ each rising over 3,000 meters."  },
]

export const alumni = [
  
  { header: "Alumni" },
  {
    name: "Stephanie Liu",
    title: "",
    img: "stephanie-liu",
    education: "Northeastern University",
    alt: "Stephanie is wearing a brown sweater and smiling.",
    linkedIn: "https://www.linkedin.com/in/stephanie-liu-northeastern",
    awards: "• Northeastern National Merit Scholar • Northeastern PEAK Summit Award • Srimivasan Award for Projects in Emerging Markets.",
    program: "Training",
    major: "Bioengineering",
    research: "Monte Carlo and Molecular Dynamics",
    bio: "Stephanie is a bioengineering major with a minor in mathematics and a concentration in systems, synthetic, and computational bioengineering. Since joining the lab in June 2024, her research focuses on elucidating the behaviour of palmitic acid at the air-water interface of the alveolar lining through Monte Carlo simulations and homology modeling. Outside of the lab, she enjoys music, spending time with her friends, and going to concerts."
  },
  {
    name: "Amanda Ferrante",
    title: "",
    img: "amanda",
    education: "Northeastern University",
    major: "Bioengineering, Biochemistry",
    linkedIn: "https://www.linkedin.com/in/am-ferrante/",
    program: "Alveolar Interface",
    research: "Amanda’s research project, 'Atomistic Investigations of the Pulmonary Surfactant (PS) System through Examining SP-C and Cholesterol Interactions for Advancements in Respiratory Health' aims to unravel the intricate interactions between SP-C and cholesterol is critical for understanding respiratory health.",
    alt: "Amanda is wearing a black shirt.",
    bio: "Amanda is a senior undergraduate student at Northeastern University studying Bioengineering and Biochemistry. Her research in the COMBINE Lab focuses on using computational chemistry and molecular modeling to dissect lung physiology at the atmomistic level. She investigates the interactions of pulmonarysurfactant protiens with cholesterol to better understand the biophysics of gas exchange with implications for conditions such as Long COVID, ARDS and COPD. Amanda also develops structural models of the surfactant protiens to address gapsin experimental data to improve modeling of the pulmonary surfactant system. She has presented her work at national conferences and is a recipient of Northeastern's PEAK Experience Ascent and Summit Awards.",
  },
  {
    name: "Amit Shenoy",
    title: "",
    img: "amit",
    education: "Northeastern University",
    linkedIn: "http://www.linkedin.com/in/itsamit",
    major: "Bioengineering",
    program: "Immunoproteins",
    awards: "• Lead360 Emerging Leader Award • National Piano Guild Award • Dean's List, Honors Program",
    research: "Investigating how Mannose-Binding-Lectin (MBL), a human first-line-of-defense protein binds to various viral pathogens. The results, to be measured in binding affinity, hydrogen bond fraction, structural changes, etc. could help future host-pathogen research, aid in biomarker development, and provide leads for therapeutic drug discovery.",
    alt: "Amit is wearing a blue striped tie and light blue collared shirt.",
    bio: "Amit's research investigates how Mannose-Binding-Lectin (MBL), a human first-line-of-defense protein, binds to various viral pathogens. The results, to be measured in binding affinity, hydrogen bond fraction, structural changes, etc., could help future host-pathogen research, aid in biomarker development, and provide leads for therapeutic drug discovery.Amit enjoys a good mystery and solving challenges alongside a team. His interests include strategy games, social justice activism, and bioengineering.",
  },
   {
    name: "Lakshmi Sowjanya Nadimpalli",
    title: "Master of Science in Bioinformatics",
    img: "lakshmi",
    education: "Northeastern University",
    major: "Bioinformatics",
    linkedIn:"",
    research: "Training",
    alt: "Lakshmi is smiling.",
    bio: "Lakshmi Sowjanya Nadimpalli is a graduate student in Bioinformatics with interests in genomics, multi-omics, computational biology, drug discovery, and data science. I'm passionate about app;ying integrative computational approaches to advance biomedical research and therapeutic development. Outside the lab, I enjoy travelling, exploring new things, exploring science and knowing about it.",
  },
  {
    name: "Amelia Leuschner",
    title: "",
    img: "Amelia_leuschner",
    education: "Northeastern University",
    linkedIn: "www.linkedin.com/in/amelia-leuschner-a3a242291",
    major: "Bioengineering",
    alt: "Ann is wearing a white shirt.",
    bio: "Amelia is a third year Bioengineering major interested in computational bioengineering. She is from a small community in New Hamshire that operates an organice farm. Outside of the lab, she enjoys crochet, reading and hiking in the white mountains.",
  },
  {
    name: "Isha Valluri",
    title: "Bachelor of Science in Bioengineering",
    img: "ishavalluri",
    education: "Northeastern University",
    major: "Systems,Synthetic and Computational Bioengineering",
    linkedIn: "https://www.linkedin.com/in/valluri-isha/",
    research: "Training",
    alt: "isha is smiling.",
    bio: "Isha is a bioengineering major with a concentration in systems,synthetic and computational bioengineering and a minor in data science. During her free time Isha enjoys listening to music , reading fantasy and sci-fi novels, and playing video games.",
  },
  {
    name: "Jack Amoreno",
    title: "Senior Bioengineering student",
    img: "jackamoreno",
    education: "Northeastern University",
    major: "Cell and tissue engineering",
    linkedIn: "https://www.linkedin.com/in/jack-amoreno/",
    research: "Training",
    alt: "jack is smiling.",
    bio: "I am a senior Bioengineering student concentrating in cell and tissue engineering.I am always interested in learning more about biotechnology,and I am excited to join the biotechnology industry post-graduation.I am from New Jersey, and i enjoy rooting for New York sports,golf and trying new coffee shops.",
  },
  {
    name: "Ann Titus",
    title: "",
    img: "ann2",
    education: "Northeastern University",
    linkedIn:"www.linkedin.com/in/ann-titus-049111271",
    major: "Bioengineering",
    program: "Alveolar Interface",
    awards:"• Base Camp Award Winner • Ascent Award Winner",
    research:"Using Monte Carlo methods based in Python to model the coexistence curve of Pentadecanoic Acid, a compound used to computationally model the monolayer at the liquid-vapor interface of the lungs.",
    alt: "Ann is wearing a white shirt.",
    bio: "Ann's research uses Monte Carlo methods based in Python to model the coexistence curve of Pentadecanoic Acid, a compound used to computationally model the monolayer at the liquid-vapor interface of the lungs.Ann Titus is a bioengineering major concentrating in cell and tissue engineering. Outside of school, she is a dancer on Northeastern’s Bhangra Team, a Residential Assistant, plays the violin, and loves traveling.",
  },
   {
    name: "Paloma Figueroa",
    title: "",
    img: "paloma2",
    education: "Northeastern University",
    alt: "Paloma is wearing a brown turtle neck.",
    linkedIn:"https://www.linkedin.com/in/paloma-figueroa/",
    awards:"• Srinivasan Award for Projects in Emerging Markets • Richard J. Scranton Fund Organization Grant • National Science Foundation Research Experience for Undergraduates (REU) • PEAK Ascent Award",
    program: "Immunoproteins",
    major: "Bioengineering",
    research:"Deciphering ManLAM Interactions: Computational Insight into MBL Binding to Tuberculosis ",
    bio: "Paloma’s research focuses on 'Deciphering ManLAM Interactions: Computational Insight into MBL Binding to Tuberculosis'. Paloma is from Dallas, Texas but originally born in San Juan, Puerto Rico. She has been a part of the COMBINE Lab since Fall 2021. Outside of the lab, she enjoys music, traveling to new places, and going to the gym.",
    // bio: "Hi! My name is Paloma and I am a second-year bioengineering student with a concentration in Medical Devices and Bioimaging. I am from Dallas, Texas but originally born in San Juan, Puerto Rico. I have been involved in the COMBINE Lab since September 2021. My research focuses on analyzing the relationship between Mannose Binding Lectin and Tuberculosis using Molecular Dynamics. Outside of the lab, I enjoy music, traveling to new places, and going to the gym!",
  },
  {
    name: "Jake Duffy",
    title: "",
    img: "jake",
    alt: "Jake is wearing a white shirt and glasses.",
    awards: "Alveolar InterfaceG7	Peak award summer 2020",
    bio: "My name is Jake, and I’m a computer science and physics student. I grew up about 45 minutes north of Chicago. I’m working on Monte Carlo simulations of pentadecanoic acid (PDA), and I’m excited to be conducting research in computational chemistry as it both applies my computer science curriculum as well as extends my knowledge to a new field.",
  },
  {
    name: "Liam Farley",
    title: "",
    img: "liam",
    alt: "Liam is wearing a navy blue collar shirt with white polka dots.",
    awards: "",
    bio: "My name is Liam, I am a senior year chemistry student at Reed College. I am Brazilian-American who loves snowboarding, hiking, and the ocean. I am excited to be expanding my knowledge into the field of biology and developing my computational research skills. Currently, I am using molecular docking and molecular dynamics simulations to study SARS-CoV-2 proteins and identify possible drug leads.",
  },
  {
    name: "Tyler Locke",
    // position: "- PhD Biomedical Engineering Student - Cornell University",
    title: "",
    img: "tyler",
    alt: "Tyler is wearing a bow tie on a checkered shirt with a gray blazer.",
    awards: "Peak Award summer 2021",
    bio: "Tyler was an undergraduate researcher in the COMBINE lab from 2020-2023. During that time, he focused on understanding the lipid-modulating function of surfactant Protein B using comparative modeling and molecular dynamics simulation. He is currently pursuing a phD in Biomedical engineering at Cornell Univeristy, working with novel optical microscopy techniques to study heart disease.",
  },
  {
    name: "Aastha Mahapatra",
    title: "",
    img: "aastha",
    alt: "Aastha is wearing a red embroidered shirt and glasses.",
    awards: "Northeastern Bioengineering Research Symposium Award",
    bio: "Hello! my name is Aastha, and I am pursuing master’s in regulatory affairs at the college of professional studies. I recently joined the Dr. Minkara’s lab as a research assistant. My research mainly focuses on applying the molecular docking analysis technique on pulmonary surfactant proteins to establish a distinction between the binding patterns of these proteins with different molecules. This research will give me a base to expand further and use molecular dynamics to study the molecular level mechanisms of the pulmonary surfactant system, mainly that of pulmonary surfactant A (SP-A). I have completed my bachelor’s degree in pharmacy my concentration being computer aided drug designing from Siksha O Anusandhan University, Bhubaneswar, India. I also like playing basketball and travelling to different places.",
  },
  {
    name: "Carolina Escobar Palacio",
    title: "",
    img: "carolina",
    alt: "Carolina is wearing a red and purple striped jacket overlooking a body of water.",
    awards: "",
    bio: "Hello! My name is Carolina and I’m a third-year bioinformatics student. I finished high school in 2013 in Medellin, Colombia (where I was also born) and I’ve been living in the U.S. for 6 years now. In the combine lab, I’m using molecular dynamics simulations to study SARS-CoV-2 proteins. I’m very excited about my project as I will be using different concepts of bioinformatics and apply them to such a relevant topic! My long-term goal is to pursue a PhD and do research related to computational chemistry.",
  },
  {
    name: "Rohit Paradkar",
    title: "",
    img: "rohit",
    alt: "Rohit is wearing a dark hoodie.",
    awards: "",
    bio: "Rohit Paradkar is a sophomore at Newton South High School. He’s originally from Colorado Springs, Colorado, and loves to ski and spend time outdoors. He’s very passionate about chemistry, biology, and computer science. He also loves to play tennis and watch football. His work in COMBINE lab deals with molecular docking for SARS-CoV-2 drug discovery.",
  },
  
  {
    name: "Lydia Ruffner",
    title: "",
    img: "lydia",
    alt: "Lydia is wearing a black collar shirt and black cardigan.",
    bio: "Lydia Ruffner is a Postdoctoral Research Associate in the Department of Bioengineering. Her research in the COMBINE lab focuses on exploring the function of proteins in the pulmonary surfactant system such as surfactant protein C (SP-C). She recently defended her PhD from the Department of Chemistry and Chemical Biology at Northeastern University in early 2021. Her dissertation work used enzyme structure to determine the global and local structural differences in dynamics that may lead to the functional characterization of important disease related enzymes in uncharacterized metabolic pathways for pharmaceutical application. She is an alumna of Spelman College (C’14) where she majored in Biochemistry with a minor in Mathematics. Born in a DMV (DC, Maryland and Virginia) native who loves to traveling and enjoys spending times with family and friends.",
  },
 
  {
    name: "Catherine Zhou",
    title: "",
    img: "catherine",
    alt: "Catherine is wearing a gray sweater vest and white collar shirt.",
    awards: "",
    bio: "Hi! I’m Catherine, and I’m a first-year Chemical Engineering and Biochemistry major pursuing the pre-med track. I’m from the suburbs north of Dallas, TX. I will soon be working on researching the vapor liquid coexistence of pentadecanoic acid and palmitic acid using Monte Carlo Simulations. I am excited to apply my chemical engineering knowledge to real-world research, and to further sharpen my programming skills along the way.",
  },

 
];
